<template>
    <div class="section-stream-description" :class="color">
        <LayoutContained :class="padding">
            <ClientOnly>
                <ContentSubheading
                    v-if="subheading"
                    :heading="subheading"
                    headingComponent="h3"
                    headingColor="text-zinc-500"
                    marginBottom="mb-4"
                ></ContentSubheading>
            </ClientOnly>
            <ContentHeading
                v-if="heading"
                :class="content ? 'mb-4' : ''"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                :textCentered="textCentered"
            ></ContentHeading>
            <ContentText
                v-if="content"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></ContentText>
            <ContentText
                v-if="discordPromptContent"
                :html="discordPromptContent"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></ContentText>
            <slot name="custom"></slot>
        </LayoutContained>
    </div>
</template>

<script>
export default {
    name: 'SectionStreamDescription',
    props: {
        stream: {
            required: false,
            type: Object,
            default () {
                return {};
            },
        },
        error: {
            required: false,
            type: String,
            default: null,
        },
        padding: {
            required: false,
            default: 'py-12',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        heading () {
            if (this.error || this.stream?.stream_status === 'past') return 'Stream Ended';
            return this.stream?.stream_title;
        },
        subheading () {
            if (import.meta.server || this.stream?.stream_status === 'past') return null;
            if (this.stream?.stream_status === 'active' && this.stream?.stream_starts > new Date() && this.stream?.stream_time_from_now) return `${this.stream?.stream_time_from_now}`;
            if (this.stream?.stream_status === 'active') return 'Stream Live NOW!';
            if (this.stream?.stream_starts_long_date) {
                return this.stream.stream_starts_long_date + ' at ' + this.stream.stream_starts_short_time;
            }
            return null;
        },
        content () {
            if (this.error || this.stream?.stream_status === 'past') return '<p>That stream has finished. Look out for the replay!</p>';
            if (!this.stream?.stream_description) return '<ArticleLiveStreamFallbackDescription />';
            return this.stream?.stream_description;
        },
        discordPromptContent () {
            return '<ArticleDiscordPrompt />';
        },
    },
};
</script>
